import { Link } from 'react-router-dom';
import { latestVideos } from '@/mocks/videos';

export default function LatestVideos() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
              最新上线
            </h2>
            <p className="text-sm text-foreground-500">刚刚更新的热门内容</p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            全部新内容 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {latestVideos.map((video) => (
            <Link
              key={video.id}
              to="/category/dianshiju"
              className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  title={`${video.title} - 黄瓜视频在线最新上线`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded text-xs font-medium bg-accent-500 text-white">
                    {video.category}
                  </span>
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className="text-xs text-white/90 bg-black/50 px-1.5 py-0.5 rounded">
                    {video.duration}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="font-heading text-sm text-foreground-900 mb-1 line-clamp-1">
                  {video.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{video.views} 次播放</span>
                  <span className="flex items-center gap-0.5">
                    <i className="ri-star-fill text-accent-500 text-xs w-3 h-3 flex items-center justify-center"></i>
                    {video.rating}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}